import { render, staticRenderFns } from "./RateDialog.vue?vue&type=template&id=923f05be&scoped=true&"
import script from "./RateDialog.vue?vue&type=script&lang=js&"
export * from "./RateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923f05be",
  null
  
)

export default component.exports